import { LOCALES, isLocalHost } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';

// When editing it, you also need to edit its style
export const framesId: string = 'frames';

enum ZohoPosition {
  RIGHT = 'BOTTOM RIGHT',
  LEFT = 'BOTTOM LEFT',
}

enum BeamerDisplay {
  RIGHT = 'right',
  LEFT = 'left',
}

class Frames {
  public initialize() {
    if (isLocalHost) return;

    const framesContainer: HTMLElement | null = document.getElementById(framesId);
    if (!framesContainer) return;

    this.initBeamer(framesContainer);
    // https://taker.atlassian.net/browse/TM-3025
    // Waiting RN WebView init scripts
    setTimeout(() => {
      if (!window.IS_MOBILE) {
        this.initZoho(framesContainer);
      }
    }, 3000);
  }

  private initZoho(framesContainer: HTMLElement) {
    if (!window) return;

    window.ZohoHCAsapSettings = {
      ...window.ZohoHCAsapSettings,
      customLayoutId: framesId,
      hideLauncherIcon: true,
      styles: {
        ...(window.ZohoHCAsapSettings?.styles || {}),
        position: localeStore.isRtlLanguage ? ZohoPosition.LEFT : ZohoPosition.RIGHT,
      },
    };

    const script: HTMLScriptElement = document.createElement('script');

    script.defer = true;
    script.async = true;
    script.src = 'https://desk.zoho.com/portal/api/web/inapp/426576000000309001?orgId=694795304';

    framesContainer?.appendChild(script);
  }

  private initBeamer(framesContainer: HTMLElement) {
    if (!window) return;

    window.beamer_config = {
      ...window.beamer_config,
      product_id: 'FMYjYRZI31895', // DO NOT CHANGE: This is your product code on Beamer
      selector: 'beamer-open-btn', // Optional: Id, class (or list of both) of the HTML element to use as a button
      display: localeStore.isRtlLanguage ? BeamerDisplay.LEFT : BeamerDisplay.RIGHT, // Optional: Choose how to display the Beamer panel in your site
      // top: 0, // Optional: Top position offset for the notification bubble
      // right: 0, // Optional: Right position offset for the notification bubble
      // bottom: 0, // Optional: Bottom position offset for the notification bubble
      // left: 0, // Optional: Left position offset for the notification bubble
      // button_position: 'bottom-right', // Optional: Position for the notification button that shows up when the selector parameter is not set
      // icon: 'bell_lines', // Optional: Alternative icon to display in the notification button
      language: LOCALES.AR_UPPERCASE, // Optional: Bring news in the language of choice
      // language: localeStore.language === LOCALES.AR ? LOCALES.AR_UPPERCASE : LOCALES.EN_UPPERCASE,
      // filter: 'admin', // Optional : Bring the news for a certain role as well as all the public news
      // lazy: false, // Optional : true if you want to manually start the script by calling Beamer.init()
      // alert : true, // Optional : false if you don't want to initialize the selector
      // delay : 0, // Optional : Delay (in milliseconds) before initializing Beamer
      // embed : false, // Optional : true if you want to embed and display the feed inside the element selected by the 'selector' parameter
      mobile: false, // Optional : false if you don't want to initialize Beamer on mobile devices
      //
      // notification_prompt : 'sidebar',
      // Optional : override the method selected to prompt users for permission to receive web push notifications
      //
      // callback : your_callback_function,
      // Optional : Beamer will call this function, with the number of new features as a parameter, after the initialization
      //
      // onclick : your_onclick_function(url, openInNewWindow),
      // Optional : Beamer will call this function when a user clicks on a link in one of your posts
      //
      // onopen : your_onopen_function, // Optional : Beamer will call this function when opening the panel
      // onclose : your_onclose_function, // Optional : Beamer will call this function when closing the panel

      // ---------------Visitor Information---------------//

      // user_firstname : "firstname", // Optional : Input your user firstname for better statistics
      // user_lastname : "lastname", // Optional : Input your user lastname for better statistics
      // user_email : "email", // Optional : Input your user email for better statistics
      // user_id : "user_id" // Optional : Input your user ID for better statistics
    };

    const script: HTMLScriptElement = document.createElement('script');

    script.defer = true;
    script.async = true;
    script.src = 'https://app.getbeamer.com/js/beamer-embed.js';

    framesContainer?.appendChild(script);
  }
}

const frames = new Frames();

export default frames;
